import { memo, useMemo } from "react";
import { useSearchParams } from "solito/navigation";
import GatheringAccessEnum from "src/api/graphql/__generated__/enums/GatheringAccessEnum";
import GatheringPrivacy from "src/api/graphql/__generated__/enums/GatheringPrivacy";
import { useGatheringStore } from "src/contexts/GatheringContext";
import useMountEffect from "src/hooks/useMountEffect";
import { useModal } from "src/modals";
import GatheringModal from "src/modals/configs/GatheringModal";
import usePresentPhoto from "../hooks/usePresentPhoto";

const PresentSearchParamModal = () => {
	const search = useSearchParams<{
		photo?: string;
		commentId?: string;
	}>();
	const presentPhoto = usePresentPhoto();
	const gatheringId = useGatheringStore((state) => state.gatheringId);
	const access = useGatheringStore((state) => state.access);
	const privacy = useGatheringStore((state) => state.privacy);
	const { presentModal } = useModal<GatheringModal>();
	const { commentId, photoId } = useMemo(
		() => ({
			commentId: search?.get("commentId"),
			photoId: search?.get("photo"),
		}),
		[search],
	);

	useMountEffect(() => {
		if (photoId && photoId.length === 36) {
			presentPhoto({
				photoId,
			});
			return;
		}
		if (
			commentId &&
			commentId.length === 36 &&
			privacy?.includes(GatheringPrivacy.EnableComments)
		) {
			presentModal("GatheringCommentsThread", {
				props: {
					gatheringId,
					isAdmin: access === GatheringAccessEnum.Admin,
				},
			});
			return;
		}
		// Be very careful with this with regards to optimistic updates
		// commentId is safe since it's only change if the route changes from notification (there's no client-side route updates for the commentId field)
	}, [commentId]);

	return <></>;
};
export default memo(PresentSearchParamModal);
